export default __webpack_public_path__ + "static/media/browser-about-us.92d52462.png";